import PhoneVerifyForm from "../components/PhoneVerifyForm";

export default function PhoneNumber() {
  return (
    <div className="relative z-10 w-full max-w-md px-6 py-40">
      <div className="flex justify-center mb-8">
        <img src="/brand-logo.svg" alt="phone" className="w-17 h-17" />
      </div>
      <PhoneVerifyForm />
    </div>
  );
}
